import { render, staticRenderFns } from "./EditorialBoard.vue?vue&type=template&id=fe042c10&scoped=true"
import script from "./EditorialBoard.vue?vue&type=script&lang=js"
export * from "./EditorialBoard.vue?vue&type=script&lang=js"
import style0 from "./EditorialBoard.vue?vue&type=style&index=0&id=fe042c10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe042c10",
  null
  
)

export default component.exports